// The published contact (PRD S5, OSA/DSA): a real address and what happens when you write.
import { createFileRoute } from "@tanstack/react-router";
import { Icon } from "../components/Icon";
import { StaticHead, StaticPage, staticStyles as s } from "../components/StaticPage";
import { useTitle } from "../lib/useTitle";
import r from "./static.module.css";

export const Route = createFileRoute("/contact")({ component: Contact });

const ADDRESS = "fellowship@biblestandard.app";

function Contact() {
  useTitle("Contact");
  return (
    <StaticPage>
      <StaticHead
        title={
          <>
            Write to a person, <em>not a form.</em>
          </>
        }
        lead="For safety, a report, your data, or anything else. We reply within a day on weekdays."
      />
      <a href={`mailto:${ADDRESS}`} className={r.mail}>
        <span className={r.mailIcon} aria-hidden="true">
          <Icon name="email" size={22} />
        </span>
        <span className={r.mailWords}>
          <span className={r.mailLabel}>Email</span>
          <span className={r.mailAddress}>{ADDRESS}</span>
        </span>
        <Icon name="forward" size={20} />
      </a>
      <aside className={r.urgent} aria-label="In an emergency">
        <Icon name="shield" size={20} />
        <p>
          If someone is in immediate danger, call <strong>999</strong> in the UK or <strong>112</strong> in the EU.
        </p>
      </aside>
      <p className={`${s.prose} ${r.after}`}>To report a post, comment or profile, choose Report in its menu: it goes straight to the people who act on reports.</p>
    </StaticPage>
  );
}
